export type AuthMode = "local" | "auth0" | "both";

/**
 * Auth mode for the login UI.
 *
 * Defaults to `auth0` when unset so production (Docker/terraform) keeps
 * Auth0/Google sign-in even if `REACT_APP_AUTH_MODE` is missing from env.
 * Local/Cloud Agent testing must set `REACT_APP_AUTH_MODE=local` explicitly
 * (see `.env.example` and `.cursor/install.sh`).
 */
export const getAuthMode = (): AuthMode => {
  const mode = String(process.env.REACT_APP_AUTH_MODE || "auth0").toLowerCase();

  if (mode === "auth0" || mode === "both" || mode === "local") {
    return mode;
  }

  // Unrecognized values (including an unsubstituted `$REACT_APP_AUTH_MODE`
  // placeholder) must not disable Auth0 in production.
  return "auth0";
};

export const isLocalAuthEnabled = (mode: AuthMode = getAuthMode()) =>
  mode === "local" || mode === "both";

export const isAuth0Enabled = (mode: AuthMode = getAuthMode()) =>
  mode === "auth0" || mode === "both";
